import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { RateOperatorComponent } from 'src/app/pages/calendar/components/rate-operator/rate-operator.component';
import { HttpService } from 'src/app/services/http.service';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sections',
  templateUrl: './sections.component.html',
  styleUrls: ['./sections.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionsComponent implements OnInit, OnDestroy {
  @Input() set home(value: any[]) {
    if (value && value.length) {
      this.setSections(value);
    }
  }
  public domainId = environment.domainId;
  private _querySubs?: Subscription = undefined;
  private _filter = {
    category: '',
    orden: '',
    promo: '',
    from: '',
    upTo: '',
    domainId: this.domainId,
  };

  private _sections = undefined;

  get sections() {
    return this._sections;
  }
  set sections(value) {
    this._sections = value;
  }

  constructor(
    private navCtrl: NavController,
    private cdr: ChangeDetectorRef,
    public paramSv: ParamServicesService,
    private route: ActivatedRoute,
    private uiSv: UiServices,
    private httpSv: HttpService
  ) {}

  async ngOnInit() {
    try {
      this._querySubs = this.route.queryParamMap.subscribe((params) => {
        if (params.get('operatorId')) {
          this.uiSv.showModal(
            RateOperatorComponent,
            { operatorId: params.get('operatorId') },
            'modal-sm'
          );
        }
      });

      const param = this.route.snapshot.queryParamMap.get('successPaym');
      const orderIdB = this.route.snapshot.queryParamMap.get('ori');
      const cart = this.route.snapshot.queryParamMap.get('cart');
      if (param === '1' && orderIdB) {
        const params: any = this.getQueryParams(location.search);
        const desencryptedOrder = JSON.parse(atob(orderIdB));
        if (desencryptedOrder.type === 'paguelofacil') {
          if (+params.TotalPagado >= 0 && params.Estado == 'Denegada') {
            await this.uiSv.presentAlert(
              `Estado: <b> ${params.Estado} </b> <br/><br/>Razón: <b>${params.Razon} </b>`,
              false,
              'Continuar',
              true,
              'S',
              'Su pago ha presentado problema'
            );
            await this.navCtrl.navigateRoot('/home', {
              replaceUrl: true,
            });
            return;
          }
        }

        await this.uiSv.showLoading(
          'Procesando su pago. No cierre la pestaña antes de terminar.'
        );

        await this.httpSv.itemIndex(
          'purchase/pagosbg',
          '',
          { orderData: orderIdB },
          ''
        );

        await this.uiSv.loading.dismiss();
        await this.uiSv.presentAlert('Su pago esta siendo procesado.');

        const dataCart = atob(cart);

        const openWp = this.paramSv?.dispatch?.value;
        if (openWp === 'wpp' || openWp === 'both') {
          window.open(
            `https://wa.me/${this.paramSv.numWpp}?text=${dataCart}`,
            '_blank'
          );
        }
      } else if (param === '0') {
        await this.uiSv.presentAlert(
          'Ha ocurrido un error procesando su pago.'
        );
      }

      await this.navCtrl.navigateRoot('/home', {
        replaceUrl: true,
      });
    } catch (error) {
      console.log('error :>> ', error);
    } finally {
      await this.uiSv.loading?.dismiss();
    }
  }

  getQueryParams(url) {
    let queryParams = {};
    let urlParams = new URLSearchParams(url);

    urlParams.forEach((value, key) => {
      queryParams[key] = value;
    });

    return queryParams;
  }

  setSections(home) {
    const sections = home.filter((item) => {
      if (
        (typeof item[item.type] === 'object' && item[item.type].length) ||
        !item[item.type]
      ) {
        return item;
      } else if (item.type === 'sponsor') {
        if (item.sponsor.sponsors && item.sponsor.sponsors.length) {
          return item;
        }
      } else if (item.type === 'specialButton') {
        return item;
      }
    });
    this.sections = sections;
    console.log('this.sections :>> ', this.sections);
    this.cdr.detectChanges();
  }

  trackByItems(index, item) {
    return item.id ? item.id : item;
  }

  goMarketplace(id) {
    this._filter.category = id;
    const queryParams = this._filter;
    this.navCtrl.navigateForward('marketplace', { queryParams });
  }

  ngOnDestroy(): void {
    if (this._querySubs) {
      this._querySubs.unsubscribe();
    }
  }
}
